import Link from "next/link";
import Image from "next/image";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
} from "react-icons/fa";
import { resolveLegacyLink } from "../utils/linkUtils";


type FooterLogo = {
  url: string;
  alternativeText?: string;
};

type FooterSubMenuItem = {
  id?: number | string;
  subText: string;
  subLink: string;
};

type FooterMenuItem = {
  id?: number | string;
  textItem: string;
  submenu: FooterSubMenuItem[];
};

type FooterProps = {
  menuFooter: FooterMenuItem[];
  logoFooter: FooterLogo;
};

export const Footer = ({ menuFooter, logoFooter }: FooterProps) => {

  return (
    <footer className="bg-dark text-white py-12 lg:px-20">
      <div className="lms-container">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-10">
          <div>
            <Link href="/">
              <Image
                src={logoFooter.url}
                alt={logoFooter.alternativeText || ""}
                width={120}
                height={120}
                className="w-[90px] sm:w-[110px] lg:w-[120px] h-auto"
              />
            </Link>
          </div>
          {menuFooter.map((item, k) => (
            <div key={item.id ?? k}>
              <h4 className="text-[#7EC321] font-bold mb-3 text-2xl">
                {item.textItem}
              </h4>

              {item.submenu.map((submenu, i) => {
                const isExternal =
                  submenu.subText === "Espace client" ||
                  submenu.subText === "Devenir franchisé";

                return (
                  <ul className="space-y-2 text-xl pb-3 font-medium"  key={submenu.id ?? i}>
                    <Link

                      target={isExternal ? "_blank" : undefined}
                      href={
                        isExternal
                          ? submenu.subLink
                          : resolveLegacyLink(submenu.subLink, "main")
                      }
                    >
                      <li className="hover:text-primaryGreen">
                        {submenu.subText}
                      </li>
                    </Link>
                  </ul>
                );
              })}
            </div>
          ))}

        </div>

        <div className=" flex flex-col lg:flex-row items-center justify-between text-sm">
          <p>© 2024 LES MENUS SERVICES. Tous droits réservés.</p>

          {/* Bloc des réseaux sociaux */}
          <div className="flex gap-4 mt-4 lg:mt-0">

            {/* FACEBOOK */}
            <Link
              href="https://www.facebook.com/lesmenusservicesofficiel/"
              target="_blank"
              rel="noopener noreferrer"
              className="group"
            >
              <div className="bg-primaryGreen w-14 h-14 rounded-xl flex items-center justify-center
                      text-dark group-hover:bg-greenPastel transition-all">
                <FaFacebookF size={24} />
              </div>
            </Link>

            {/* INSTAGRAM */}
            <Link
              href="https://www.instagram.com/lesmenusservices/"
              target="_blank"
              rel="noopener noreferrer"
              className="group"
            >
              <div className="bg-primaryGreen w-14 h-14 rounded-xl flex items-center justify-center
                      text-dark group-hover:bg-greenPastel transition-all">
                <FaInstagram size={26} />
              </div>
            </Link>

            {/* LINKEDIN */}
            <Link
              href="https://www.linkedin.com/company/les-menus-services/"
              target="_blank"
              rel="noopener noreferrer"
              className="group"
            >
              <div className="bg-primaryGreen w-14 h-14 rounded-xl flex items-center justify-center
                      text-dark group-hover:bg-greenPastel transition-all">
                <FaLinkedinIn size={26} />
              </div>
            </Link>

            {/* YOUTUBE */}
            <Link
              href="https://www.youtube.com/user/LesMenusServices"
              target="_blank"
              rel="noopener noreferrer"
              className="group"
            >
              <div className="bg-primaryGreen w-14 h-14 rounded-xl flex items-center justify-center
                      text-dark group-hover:bg-greenPastel transition-all">
                <FaYoutube size={28} />
              </div>
            </Link>
          </div>

          {/* Badge "service à la personne" */}
          <div className="flex flex-row justify-center gap-5 mt-5 lg:mt-0">

            <Image
              src="https://site-lms.fra1.digitaloceanspaces.com/service_a_personne_dbb0391c24.png"
              alt="Service à la personne"
              width={100}
              height={100}
            />
            <Image
              src="https://site-lms.fra1.digitaloceanspaces.com/EXE_LOGO_TM_2_F_2025_01_r8gau53lx5lix5x6c98n96aon1fq4k8tncplit40gq_141e2cc5b0.webp"
              alt="Service à la personne"
              width={100}
              height={100}
            />
            <Image
              src="https://site-lms.fra1.digitaloceanspaces.com/label_satisfaction_4_3_r7dz5q3nuza2u22g0b66mbrl1gqnhf2nvik7qayue2_3e7a93c7aa.webp"
              alt="Service à la personne"
              width={100}
              height={100}
            />
          </div>
        </div>
      </div>


    </footer>
  );
};
